/** match | under | over */
export const LINE_COMPARE_STATUS = {
  MATCH: 'match',
  UNDER: 'under',
  OVER: 'over',
};

export const LINE_STATUS_FILTER = {
  ALL: 'all',
  UNDER: 'under',
  OVER: 'over',
  MATCH: 'match',
};

export const getLineReferenceLabel = (fromERP) => (fromERP ? 'Док' : 'Залишок');

export const getLineReferenceQty = (line, fromERP) => {
  if (!line) return 0;
  if (fromERP) return Number(line.quantityERP ?? 0);
  return line.quantityStock != null ? Number(line.quantityStock) : 0;
};

export const getCompareStatus = (referenceQty, quantityActual) => {
  const ref = Number(referenceQty ?? 0);
  const actual = Number(quantityActual ?? 0);
  if (Math.abs(actual - ref) < 0.0001) return LINE_COMPARE_STATUS.MATCH;
  if (actual < ref) return LINE_COMPARE_STATUS.UNDER;
  return LINE_COMPARE_STATUS.OVER;
};

export const lineMatchesStatusFilter = (line, fromERP, filter) => {
  if (filter === LINE_STATUS_FILTER.ALL) return true;
  const status = getCompareStatus(getLineReferenceQty(line, fromERP), line.quantityActual);
  return status === filter;
};
